module.exports = __webpack_public_path__ + "img/hand-heart-outline.3d583aaa.svg";